import { createContext, useContext } from 'react';
import { ITracker } from './ITracker';

export const TrackerContext = createContext<ITracker | null>(null);

export const useTracker = (): ITracker => {
  const tracker = useContext(TrackerContext);

  if (!tracker) {
    throw new Error('tracker missing from tracker context');
  }

  return tracker;
};
